
export const LINKS = [
  'back_to_login',
  'contact_support',
  'forgot_your_password',
];

export default {
  LINKS,
};
